import styled from 'styled-components'
import { variant } from 'styled-system'
import { P } from 'ui/acro'
import { css } from '@styled-system/css'

const CardTitle = styled(P)((props) =>
  css({
    fontFamily: props.theme.fonts.Proxima,
    fontSize: ['14px', '14px', '16px'],
    fontWeight: '700',
    letterSpacing: '0.352px',
    lineHeight: ['18px', '18px', '24px'],
    color: 'black'
  },
  variant({
    variants: {
      primary: {
        letterSpacing: '2.5px',
        fontSize: ['16px', '16px', '24px', '24px'],
        textAlign: 'center',
        lineHeight: '28px',
        fontFamily: 'Arquitecta',
        fontWeight: '600',
        textTransform: 'uppercase'
      }
    }
  }))
)

export default CardTitle
